export const getPolls = `
  query getPolls($esId: String!) {
    getPolls(pk: $esId)  {
      pk
      sk
      LSI1SK
      kind
      portalPid
      courseId
      title
      numQuestions
      numStudents
      scheduleDate
    }
  }
`;

export const getPoll = `
  query getPoll($pollId: String!) {
    getPoll(pk: $pollId) {
      pk
      sk
      numQuestions
      numStudents
      scheduleDate
      portalPid
      title
      LSI1SK
      currentQuestion
      lastAccessed
      lastInstructor
    }
  }
`;

export const getStudentPolls = `
  query getStudentPolls($studentId: String!, $pollStatus: String) {
   getStudentPolls(pk: $studentId, LSI1SK: $pollStatus) {
     pk
     sk
     kind
     title
     portalPid
   }
  }
`;

export const getPollStudents = `
  query getPollStudents($pollId: String!) {
    getPollStudents(sk: $pollId) {
      pk
      sk
      kind
    }
  }
`;

export const getPollQuestions = `
  query getPollQuestions($pollId: String!) {
    getPollQuestions(pk: $pollId)  {
      pk
      sk
      portalQid
      questionStatus
      categories
      type
      stem
      enableAllThatApply
      choices {
        choiceUID
        text
      }
      mcAnswer {
        choices {
          choiceUID
        }
      }
      tfAnswer {
        value
      }
      fitbAnswer {
        blankAnswers {
          answers
          blankUID
          choiceType
          options
        }
      }
    }
  }
`;

export const getPollQuestion = `
  query getPollQuestion($pollId: String!, $currentQuestion: String!) {
    getPollQuestion(pk: $pollId, sk: $currentQuestion)  {
      pk
      sk
      portalQid
      questionStatus
      categories
      type
      stem
      enableAllThatApply
      choices {
        choiceUID
        blankUID
        text
      }
      mcAnswer {
        choices {
          choiceUID
        }
      }
      tfAnswer {
        value
      }
      fitbAnswer {
        blankAnswers {
          answers
          blankUID
          choiceType
          options
        }
      }
    }
  }
`;

export const getPollResponses = `
  query getPollResponses($pollId: String!, $responseId: String) {
    getPollResponses(GSI2PK: $pollId, GSI2SK: $responseId) {
      GSI2PK
      GSI2SK
      pk
      sk
      response {
        choiceIndexes
        portalQid
        responseType
        text
        shortAnswerBlanks {
          blankUID
          userAnswer
        }
        userId
      }
    }
  }
`;

export const getStudentResponses = `
  query getStudentResponses($esId: String!, $responseId: String) {
    getStudentResponses(pk: $esId, sk: $responseId) {
      pk
      sk
      response {
        choiceIndexes
        portalQid
        responseType
        text
        shortAnswerBlanks {
          blankUID
          userAnswer
        }
        userId
      }
    }
  }
`;
